import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useMemo } from "react";

import { GlobeAltIcon } from "@heroicons/react/24/outline";

import { useDebugLifecycle } from "@/utils/debug/useDebugLifecycle";
import { useLanguage } from "@/utils/i18n/useLanguage";

function LanguageSelector({ variant = "default" }: { variant?: "default" | "globe" }) {
  const { allLanguages, currentLanguageLabel, setLanguage } = useLanguage();

  useDebugLifecycle("LanguageSelection", {
    data: {
      url: window.location.href,
    },
  });

  const buttonStyles = useMemo(() => {
    return variant === "globe"
      ? "bg-transparent text-gray-500 hover:text-dobu-orange cursor-pointer inline-flex"
      : "rounded-md py-2 px-4 gap-2 text-white bg-dobu-orange inline-flex items-center";
  }, [variant]);

  return (
    <Menu>
      <MenuButton className={buttonStyles}>
        {variant === "globe" ? (
          <>
            <GlobeAltIcon className="w-12 h-12 rounded p-2 hover:bg-gray-300 text-gray-500" />
          </>
        ) : (
          <>
            {currentLanguageLabel}
            <ChevronDownIcon className={"size-5 fill-white/100"} />
          </>
        )}
      </MenuButton>
      <MenuItems
        anchor="bottom"
        className="mt-1 rounded-md border border-dobu-orange/5 bg-white p-1 text-sm/6 text-dobu-black focus:outline-none"
      >
        {allLanguages.map((option) => (
          <MenuItem key={option.key}>
            {option.value === currentLanguageLabel ? (
              <button
                className="bg-dobu-orange text-white group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-dobu-orange-focus data-[focus]:text-white"
                onClick={() => setLanguage(option.key)}
              >
                {option.value}
              </button>
            ) : (
              <button
                className="group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-dobu-orange-focus data-[focus]:text-white"
                onClick={() => setLanguage(option.key)}
              >
                {option.value}
              </button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}

export default LanguageSelector;
